// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media (min-height: 300px) {\n.footer[data-v-609f4be8] {\n        position: absolute;\n        bottom: 0;\n        width: 100%;\n        padding-bottom: 10px;\n        padding-top: 10px;\n        font-size: .8rem;\n        color: rgba(36,28,21,0.65);\n}\n}\n.legal-notice[data-v-609f4be8] {\n    line-height: 1.5;\n    text-align: center;\n}\n", ""]);
// Exports
module.exports = exports;
